/**
 * @generated SignedSource<<0f856a934f2e8b24b23119410c027fcb>>
 * @relayHash 2ea5c4e6b4b4b7e5eea2703fdbce89b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 059892f6f118fc1e8a494f829489d9b83f271703b5155e1f8f4c7c4fbf64627f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GravityViewTemplateCategory = "DELIVERY" | "FEEDBACK" | "PRIORITIZATION" | "RESOURCING" | "ROADMAPPING" | "%future added value";
export type GravityViewTemplateColorScheme = "BLUE" | "DEFAULT" | "GREEN" | "LIME" | "MAGENTA" | "ORANGE" | "PURPLE" | "TEAL" | "%future added value";
export type ViewTemplatesLibraryModalEntryPointQuery$variables = {
  cloudId: string;
  locale?: string | null;
};
export type ViewTemplatesLibraryModalEntryPointQuery$data = {
  readonly gravity_viewTemplates: {
    readonly templates?: ReadonlyArray<{
      readonly category: GravityViewTemplateCategory | null;
      readonly colorScheme: GravityViewTemplateColorScheme | null;
      readonly definitions: {
        readonly fields: ReadonlyArray<{
          readonly configuration: AGG$JSON | null;
          readonly description: string | null;
          readonly global: boolean | null;
          readonly name: string;
          readonly nonReplaceable: boolean | null;
          readonly options: ReadonlyArray<AGG$JSON> | null;
          readonly ref: string;
          readonly type: string;
        }>;
      } | null;
      readonly id: string;
      readonly longDescription: AGG$JSON | null;
      readonly name: string;
      readonly screenshot: {
        readonly alt: string | null;
        readonly src: string;
        readonly srcDark: string | null;
      } | null;
      readonly shortDescription: AGG$JSON | null;
      readonly thumbnail: {
        readonly alt: string | null;
        readonly src: string;
        readonly srcDark: string | null;
      } | null;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"ViewTemplatesQueryErrorView_queryError">;
  };
};
export type ViewTemplatesLibraryModalEntryPointQuery = {
  response: ViewTemplatesLibraryModalEntryPointQuery$data;
  variables: ViewTemplatesLibraryModalEntryPointQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "src"
  },
  {
    "kind": "ScalarField",
    "name": "srcDark"
  },
  {
    "kind": "ScalarField",
    "name": "alt"
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "GravityViewTemplate",
      "kind": "LinkedField",
      "name": "templates",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "colorScheme"
        },
        {
          "kind": "ScalarField",
          "name": "shortDescription"
        },
        {
          "kind": "ScalarField",
          "name": "longDescription"
        },
        {
          "concreteType": "GravityViewTemplateImage",
          "kind": "LinkedField",
          "name": "thumbnail",
          "plural": false,
          "selections": (v3/*: any*/)
        },
        {
          "concreteType": "GravityViewTemplateImage",
          "kind": "LinkedField",
          "name": "screenshot",
          "plural": false,
          "selections": (v3/*: any*/)
        },
        {
          "concreteType": "GravityViewTemplateDefinitions",
          "kind": "LinkedField",
          "name": "definitions",
          "plural": false,
          "selections": [
            {
              "concreteType": "GravityFieldDefinition",
              "kind": "LinkedField",
              "name": "fields",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "ref"
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "type"
                },
                {
                  "kind": "ScalarField",
                  "name": "description"
                },
                {
                  "kind": "ScalarField",
                  "name": "configuration"
                },
                {
                  "kind": "ScalarField",
                  "name": "options"
                },
                {
                  "kind": "ScalarField",
                  "name": "global"
                },
                {
                  "kind": "ScalarField",
                  "name": "nonReplaceable"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "GravityViewTemplatesSuccess"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ViewTemplatesLibraryModalEntryPointQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "gravity_viewTemplates",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ViewTemplatesQueryErrorView_queryError"
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewTemplatesLibraryModalEntryPointQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "gravity_viewTemplates",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "identifier"
              },
              {
                "kind": "ScalarField",
                "name": "message"
              },
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "errorType"
                  }
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "059892f6f118fc1e8a494f829489d9b83f271703b5155e1f8f4c7c4fbf64627f",
    "metadata": {},
    "name": "ViewTemplatesLibraryModalEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dee7eb9d90c9337fb136650aa1a1ef8b";

export default node;
